export default __webpack_public_path__ + "static/media/reviro.90254ab8.svg";